import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { CurrentUser } from '../../models/current-user';
import { CurrentUserService } from '../../services/current-user.service';
import { ErrorPageComponent } from '../error-page/error-page.component';

/**
 * Displays a generic error page based on the error code from the route
 * and provides navigation and logout actions.
 */
@Component({
    selector: 'apcam-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    imports: [ErrorPageComponent, MatButtonModule, TranslatePipe],
})
export class ErrorComponent {
    messageId: string;
    user: CurrentUser | null;

    constructor(
        private readonly currentUserService: CurrentUserService,
        private readonly route: ActivatedRoute,
        private readonly router: Router
    ) {
        this.user = this.currentUserService.getCurrentUser();
        const code = this.route.snapshot.queryParams['code'] as
            string | undefined;

        this.messageId = code ?? 'default';
    }

    protected redirect(): void {
        this.router.navigate(['/auth']);
    }

    protected logout(): void {
        this.router.navigate(['/logout']);
    }
}
